import type { SpaceType } from "@circle-react/types/Space";

export const isBasicPostType = (
  postType: SpaceType,
): postType is Extract<SpaceType, "basic"> => postType === "basic";

export const isChatPostType = (
  postType: SpaceType,
): postType is Extract<SpaceType, "chat"> => postType === "chat";

export const isCoursePostType = (
  postType: SpaceType,
): postType is Extract<SpaceType, "course"> => postType === "course";

export const isEventPostType = (
  postType: SpaceType,
): postType is Extract<SpaceType, "event"> => postType === "event";

export const isMembersPostType = (
  postType: SpaceType,
): postType is Extract<SpaceType, "members"> => postType === "members";
